import React, { useEffect, useState } from "react";
import SideBar from "../Sidebar/SideBar";
import Swal from "sweetalert2";
import PaymentGatewayApi from "../../Api/PaymentGatewayApi";
import Loader from "../Loader";

const DEFAULT_JSON = {
  key_id: "",
  key_secret: "",
};

const PaymentGateway = () => {
  const [jsonText, setJsonText] = useState(JSON.stringify(DEFAULT_JSON, null, 2));
  const [loading, setLoading] = useState(false);
  const [storedData, setStoredData] = useState(null);

  const fetchPaymentGatewayData = async () => {
    setLoading(true);
    try {
      const response = await PaymentGatewayApi.GetPaymentGateway();
      if (response?.StatusCode === 200 && response?.Result) {
        const value = response.Result.value ?? DEFAULT_JSON;
        setJsonText(JSON.stringify(value, null, 2));
        setStoredData({
          id: response.Result.id,
          value,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaymentGatewayData();
  }, []);

  const handleSave = async () => {
    let parsedValue;
    try {
      parsedValue = JSON.parse(jsonText);
    } catch (error) {
      Swal.fire({
        title: "Invalid JSON",
        text: "Please enter valid JSON.",
        icon: "error",
        width: "320px",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await PaymentGatewayApi.SavePaymentGateway(parsedValue);
      if (response?.StatusCode === 200) {
        const value = response.Result.value ?? parsedValue;
        setJsonText(JSON.stringify(value, null, 2));
        setStoredData({
          id: response.Result?.id ?? 1,
          value,
        });
        Swal.fire({
          title: "Saved",
          text: "Payment Gateway data updated successfully.",
          icon: "success",
          width: "320px",
        });
      } else {
        Swal.fire({
          title: "Failed",
          text: response?.ErrorMessages || response?.error || "Unable to save Payment Gateway data.",
          icon: "error",
          width: "320px",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Flex-general-client-sidebar">
      <div className="sidebar-gen-width">
        <SideBar />
      </div>
      <div className="Main-general-Client">
        <div className="header-general">
          <h2 className="general-card-title">Payment Gateway Configuration</h2>
        </div>
        <div className="control_radius">
          <div className="company_info-text-im depart_top">JSON Value (stored in DB column: value)</div>
          <div style={{ padding: "10px" }}>
            <textarea
              className="Business_im_input mode_category1"
              value={jsonText}
              onChange={(e) => setJsonText(e.target.value)}
              rows={16}
              style={{
                width: "100%",
                fontFamily: "Consolas, monospace",
                fontSize: "14px",
                height: "200px",
              }}
            />
          </div>
          <div className="ButtonTabSave">
            <button id="SaveBtnMain" className="save-button-main-save hovered" onClick={handleSave}>
              Save
            </button>
          </div>

          <div className="company_info-text-im depart_top">Stored Data List</div>
          <div style={{ padding: "10px" }}>
            {!storedData ? (
              <div style={{ fontSize: "14px", color: "#555" }}>No data found.</div>
            ) : (
              <div style={{ border: "1px solid #ddd", borderRadius: "8px", padding: "10px" }}>
                <div style={{ marginBottom: "8px", fontWeight: 600 }}>ID: {storedData.id}</div>
                {storedData.value && typeof storedData.value === "object" ? (
                  <ul style={{ margin: 0, paddingLeft: "18px" }}>
                    {Object.entries(storedData.value).map(([key, value]) => (
                      <li key={key} style={{ marginBottom: "6px" }}>
                        <strong>{key}</strong>:{" "}
                        {typeof value === "object" ? JSON.stringify(value) : String(value)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div>{String(storedData.value)}</div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default PaymentGateway;
